<template>
  <div class="nextCourses" style="padding-bottom: 100px; max-width: 500px; margin: 0px auto">
    <div>
      <v-row v-if="loading" class="nextCourses-container">
        <v-col cols="11" class="mx-auto">
          <v-skeleton-loader v-for="n in 3" :key="n" type="list-item-avatar-two-line" class="mb-3"></v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row v-else-if="visibleCourseList.length > 0" class="nextCourses-container">
        <v-col cols="11" class="mx-auto pa-0">
          <h2 style="font-weight: 1000; font-style: italic" class="text-h6 mb-3 pl-2 d-flex justify-space-between align-center">
            GROUP FITNESS
            <v-btn @click="$router.push('/kurse')" small text color="primary">
              zum Kursplan
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </h2>
          <v-slide-y-transition group>
            <v-card
              outlined
              v-for="course in visibleCourseList"
              :key="course._id"
              class="course-card-home mb-3"
              :class="{ 'signed-up': course.signedUp, 'is-cancelled': course.cancelled }"
              @click="pushToCourse(course)">
              <v-chip
                v-if="course.signedUp && !course.onQueue && !(course.label && course.label.text) && !isLive(course)"
                small
                color="primary"
                style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                ><span style="text-transform: uppercase; font-weight: 1000; font-style: italic">Angemeldet</span></v-chip
              >
              <v-chip
                v-if="course.signedUp && course.onQueue && !isLive(course)"
                small
                color="orange"
                style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                ><span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic">Warteliste</span></v-chip
              >
              <v-chip
                v-if="!course.signedUp && course.signupAmount >= course.amount && !isLive(course) && !(course.label && course.label.text)"
                small
                color="#313131"
                style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                ><span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic">Warteliste verfügbar</span></v-chip
              >
              <v-chip
                v-if="course.label && course.label.text && (!(course.signupAmount >= course.amount) || !course.reqSignup)"
                class="white--text"
                small
                style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                :color="course.label.color">
                <span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic"> {{ course.label.text }}</span>
              </v-chip>
              <v-chip
                small
                v-if="isLive(course) && !(course.label && course.label.text)"
                class="white--text"
                style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                color="red">
                <span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic"> LIVE</span>
              </v-chip>
              <v-list-item class="pl-2 pr-1">
                <v-list-item-avatar size="56" class="course-avatar mr-3">
                  <v-img
                    :src="course.course.bild ? '/img/kurse/' + course.course.bild : '/img/lottiefiles/gf/dumbell.png'"
                    height="100%"
                    width="100%"
                    cover></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="course-title">
                    {{ course.course.name || "" }}
                    <span class="pl-1" v-if="courseRecommendations.includes(course.course._id)">
                      <v-icon small color="yellow">mdi-star</v-icon>
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="course-subtitle d-flex align-center mt-1">
                    <v-icon small>mdi-clock-outline</v-icon>
                    <span class="ml-1">{{ courseStartDate(course) }} Uhr | {{ course.duration }} Min</span>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="ma-0">
                  <div v-if="course.cancelled" class="text-center">
                    <v-avatar color="red" size="36">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-avatar>
                  </div>

                  <div v-else class="text-center mr-2">
                    <div>
                      <div v-if="course.signedUp && !course.onQueue && course.reqSignup !== false">
                        <v-progress-circular :value="calcPercentage(course)" :color="getIndicatorColor(calcPercentage(course))" size="50" width="4">
                          <span class="font-weight-bold"
                            ><span> {{ course.signupAmount || 0 }}/{{ course.amount || 0 }} </span></span
                          >
                        </v-progress-circular>
                        <div>
                          <v-icon color="primary">mdi-check-bold</v-icon>
                        </div>
                      </div>

                      <div v-else-if="course.onQueue && course.reqSignup !== false">
                        <v-progress-circular :value="100" color="orange" size="50" width="4">
                          <span class="font-weight-bold"> {{ course.queuePosition }} </span>
                        </v-progress-circular>
                        <div>
                          <v-icon color="orange">mdi-clipboard-clock</v-icon>
                        </div>
                      </div>

                      <div v-else-if="freeSpots(course) === 0 && course.reqSignup !== false">
                        <v-progress-circular :value="100" color="#313131" size="50" width="4">
                          <span> {{ course.signupAmount || 0 }}/{{ course.amount || 0 }} </span>
                        </v-progress-circular>
                        <div class="text-caption mt-1 font-weight-bold" style="line-height: 1.1">
                          <v-icon color="#313131">mdi-human-queue</v-icon>
                        </div>
                      </div>

                      <div v-else-if="course.reqSignup !== false">
                        <v-progress-circular
                          :value="((course.amount - (course.signups ? course.signups.length : 0)) / course.amount) * 100"
                          :color="getIndicatorColor(((course.amount - (course.signups ? course.signups.length : 0)) / course.amount) * 100)"
                          size="50"
                          width="4">
                          <span class="font-weight-bold">{{ course.signupAmount || 0 }}/{{ course.amount || 0 }}</span>
                        </v-progress-circular>
                      </div>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-slide-y-transition>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col class="text-center mt-5">
          <v-alert text width="100%" border="left" color="primary" class="d-flex align-center mt-2 font-weight-bold" type="info"
            >Heute keine Kurse mehr verfügbar. Schau morgen gerne wieder vorbei.</v-alert
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import api from "../../api"
import userService from "../../services/userService"
import abortService from "../../services/abortService"
import newsSlider from "../../components/news/newsSlider.vue"
import { mapState, mapGetters } from "vuex"

export default {
  name: "nextCoursesHome",
  components: { newsSlider },
  data() {
    return {
      items: [
        { show: true, label: "Nächste Kurse" },
        { show: true, label: "News" },
      ],
      selectedIndex: 0,
      userService,
      loading: true,
      courseList: [], // Komplette, ungefilterte Liste für den Tag
      visibleCourseList: [], // Sichtbare Kurse (nicht vergangen)
      ts: null,
      abortController: null,
      displayingToday: true,
      listUpdateInterval: null, // Für setInterval
    }
  },

  async created() {
    this.abortController = new abortService()
    await this.fetchCourseList()
    // Starte einen Timer, der die Liste jede Minute aktualisiert
    this.listUpdateInterval = setInterval(this.updateVisibleCourses, 60000)
  },

  beforeDestroy() {
    this.abortController.abort()
    // Wichtig: Den Timer beim Verlassen der Komponente stoppen
    clearInterval(this.listUpdateInterval)
  },

  methods: {
    isLive(course) {
      const startDate = this.$moment(course.ts * 1000).set({ hours: course.hours, minutes: course.minutes })
      const endDate = this.$moment(course.ts * 1000)
        .set({ hours: course.hours, minutes: course.minutes })
        .add(course.duration, "minutes")
      return startDate.isSameOrBefore(this.$moment(), "minute") && endDate.isSameOrAfter(this.$moment(), "minutes")
    },
    async fetchCourseList() {
      this.loading = true
      this.displayingToday = true

      try {
        const todayTs = this.$moment().set({ hours: 0, minutes: 0, seconds: 0 }).unix()
        this.ts = todayTs

        let data = await this.fetchDataForDay(todayTs, true)
        this.courseList = data // Komplette Liste speichern

        if (false && this.courseList.filter((c) => c.course).length === 0) {
          console.log("Keine Kurse für heute gefunden. Suche für MORGEN.")
          this.displayingToday = false
          const tomorrowTs = this.$moment.unix(todayTs).add(1, "days").unix()
          this.courseList = await this.fetchDataForDay(tomorrowTs, false)
        }

        this.updateVisibleCourses() // Sichtbare Kurse initial setzen

        this.items[0].show = this.courseList.length > 0
        if (!this.items[0].show && this.selectedIndex === 0) {
          this.selectedIndex = 1
        }
      } catch (error) {
        if (error.name !== "AbortError") console.error("Fehler beim Abrufen der Kursliste:", error)
      } finally {
        this.loading = false
      }
    },

    async fetchDataForDay(timestamp, useCache) {
      const cacheKey = "homeCourseData"
      const cacheDuration = 15 * 60 * 1000
      if (useCache) {
        const cached = sessionStorage.getItem(cacheKey)
        if (cached) {
          const { timestamp: cacheTimestamp, data } = JSON.parse(cached)
          if (Date.now() - cacheTimestamp < cacheDuration) {
            console.log(`Kurse für ${this.$moment.unix(timestamp).format("DD.MM")} aus Cache geladen.`)
            return data
          }
        }
      }
      try {
        console.log(`Kurse für ${this.$moment.unix(timestamp).format("DD.MM")} vom API abrufen.`)
        const data = await api.fetchCourseList(this.abortController.signal, timestamp)
        if (useCache) {
          sessionStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }))
        }
        return data
      } catch (error) {
        if (error.name !== "AbortError") console.error("API-Fehler in fetchDataForDay:", error)
        return []
      }
    },

    updateVisibleCourses() {
      console.log("Aktualisiere sichtbare Kurse...")
      if (!this.courseList) {
        this.visibleCourseList = []
        return
      }

      const now = this.$moment()
      // Filtere Kurse, deren Endzeit in der Zukunft liegt
      this.visibleCourseList = this.courseList.filter((course) => {
        if (course.cancelled) return false // Abgesagte Kurse nicht anzeigen
        const courseEndTime = this.$moment().set({ hours: course.hours, minutes: course.minutes }).add(course.duration, "minutes")
        return now.isBefore(courseEndTime)
      })

      // Wenn alle heutigen Kurse vorbei sind, lade die von morgen
      if (false && this.visibleCourseList.length === 0 && this.displayingToday) {
        console.log("Alle heutigen Kurse sind vorbei. Lade Kurse für morgen.")
        // Stoppe den Intervall kurz, um doppelte Aufrufe zu vermeiden, während geladen wird
        clearInterval(this.listUpdateInterval)
        this.fetchCourseList().then(() => {
          // Starte den Intervall neu, nachdem die neuen Daten geladen sind
          this.listUpdateInterval = setInterval(this.updateVisibleCourses, 60000)
        })
      }
    },

    getIndicatorColor(percentage) {
      return "primary"
      if (percentage <= 25) return "red darken-1"
      if (percentage <= 50) return "amber darken-1"
      return "primary"
    },

    calcPercentage(course) {
      if (course.amount > 0) {
        const free = course.amount - (course.signupAmount || 0)
        return Math.round((free / course.amount) * 100)
      }
      return 100
    },
    courseStartDate(course) {
      return this.$moment().set({ hours: course.hours, minutes: course.minutes }).format("HH:mm")
    },

    pushToCourse(course) {
      if (this.sirnachStudio) return this.$router.push("/kurse")
      const courseEndTime = this.$moment().set({ hours: course.hours, minutes: course.minutes }).add(course.duration, "minutes")
      if (this.$moment().isAfter(courseEndTime)) return // Klick auf vergangene Kurse verhindern

      let ts = course.courseTimelineId ? 0 : this.displayingToday ? this.ts : this.$moment.unix(this.ts).add(1, "days").unix()
      this.$router.push({ name: "courseListView", params: { id: course._id, ts }, query: { home: true } })
    },
  },

  computed: {
    ...mapState("userStore", ["user"]),
    ...mapGetters("userStore", ["courseRecommendations"]),

    isAdmin() {
      return this.userService.hasRight("gf_c_edit", "gf_c_delete", "gf_c_plan", "gf_c_create", "gf_cp_edit", "gf_f_courses")
    },

    listTitle() {
      return this.displayingToday ? "Heute" : "Morgen"
    },

    freeSpots() {
      return (course) => {
        if (course.amount) {
          const signedUpCount = course.signups ? course.signups.length : 0
          return Math.max(0, course.amount - signedUpCount)
        }
        return "∞"
      }
    },

    sirnachStudio() {
      return this.user && this.user.studio_id === "sirnach"
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-chip {
  background-color: var(--v-primary) !important;
  color: white;
}

.nextCourses {
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.course-card-home {
  border-radius: 18px !important;
  background: #ffffff !important;
  border: 1px solid #ededf0;
  position: relative;
  margin: 18px 0px;
  padding: 6px 0px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08) !important;
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;

  &.signed-up {
    border-left: 5px solid var(--v-primary);
  }

  &.is-cancelled {
    opacity: 0.6;
    filter: grayscale(80%);
  }
}

.course-avatar {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}

.course-title {
  font-weight: 700;
  color: #1a232e !important;
  font-size: 1rem;
  line-height: 1.4;
  align-items: center;
  display: flex;
  margin-right: 2px;
}

.course-subtitle {
  color: #5a6470 !important;
  font-size: 0.85rem;
}
</style>
